import { Injectable } from "@angular/core";
import { Apollo } from "apollo-angular";
import { Observable } from "rxjs";
import { pluck } from "rxjs/operators";
import {
  PaperConfiguration,
  PaperConfigurationInput,
  PaperConfigurationUpdateInput,
} from "../model/paper-configuration/paper-configuration";
import {
  CREATE_PAPER_CONFIGURATION,
  DELETE_PAPER_CONFIGURATION,
  FIND_PAPER_CONFIGURATIONS_BY_PUBLISHER,
  GET_PAPER_CONFIGURATION,
  UPDATE_PAPER_CONFIGURATION,
} from "../graphql/paperConfigurationGql";

@Injectable({
  providedIn: "root",
})
export class PaperConfigurationService {
  constructor(private apollo: Apollo) {}

  findByPublisher(publisherId: string): Observable<PaperConfiguration[]> {
    return this.apollo
      .query({
        query: FIND_PAPER_CONFIGURATIONS_BY_PUBLISHER,
        fetchPolicy: "no-cache",
        variables: { publisherId },
      })
      .pipe(pluck("data", "findPaperConfigurationsByPublisher"));
  }

  getById(id: string): Observable<PaperConfiguration | null> {
    return this.apollo
      .query({
        query: GET_PAPER_CONFIGURATION,
        fetchPolicy: "no-cache",
        variables: { id },
      })
      .pipe(pluck("data", "getPaperConfiguration"));
  }

  create(input: PaperConfigurationInput): Observable<PaperConfiguration> {
    return this.apollo
      .mutate({
        mutation: CREATE_PAPER_CONFIGURATION,
        variables: { input },
      })
      .pipe(pluck("data", "createPaperConfiguration"));
  }

  update(input: PaperConfigurationUpdateInput): Observable<PaperConfiguration> {
    return this.apollo
      .mutate({
        mutation: UPDATE_PAPER_CONFIGURATION,
        variables: { input },
      })
      .pipe(pluck("data", "updatePaperConfiguration"));
  }

  delete(id: string): Observable<boolean> {
    return this.apollo
      .mutate({
        mutation: DELETE_PAPER_CONFIGURATION,
        variables: { id },
      })
      .pipe(pluck("data", "deletePaperConfiguration"));
  }
}
